/**
 * @file medialogin.js
 * 各種moduleの読み込み
 */

// modules
import displayAlertOnSp from './modules/displayAlertOnSp';
import formCheck from './modules/formCheck';
import { togglePassword } from './modules/togglePassword'; // パスワード表示・非表示切り替え

displayAlertOnSp('login-form-error__text--sp');
formCheck('js-login-form', ['js-login-form-mail', 'js-login-form-password']);
togglePassword('js-toggle-password-input', 'js-toggle-password-btn');
